import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { MessagesService } from './messages.service';
import { Router } from '@angular/router';
import { APP_ROUTES } from '../contants/APP_ROUTES';
import { AlertService } from './alert.service';
import { AUTH } from '../contants/AUTH';

@Injectable()
export class LogService {

	constructor(
		private _messagesService: MessagesService,
		private _router: Router,
		private _alertService: AlertService
	) { }

	///https://angular.io/tutorial/toh-pt6
	handleError<T>(operation = 'operation', result?: T) {
		return (errorResponse: any): Observable<T> => {
			// TODO: send the error to remote logging infrastructure
			this._messagesService.add(`error encountered on ${operation}`);
			this._messagesService.add(`errorDetails => (${errorResponse.status})"${errorResponse.statusText}" @${errorResponse.url}`)

			if (errorResponse.status == '401') {
				if(errorResponse.url.indexOf('/oauth2/token') == -1){
					let count = Number(localStorage.getItem(AUTH.forceAttempt));
					if(isNaN(count)){
						count = 0
					}
					else if(count >= 3){
						this._alertService.showError('You have been trying to do things you\'re not supposed to for multiple times, you have been logged out. :(' )
						this._router.navigate([APP_ROUTES.login]);
						return;
					}

					count++;
					localStorage.setItem(AUTH.forceAttempt, count.toString());

					this._router.navigate([APP_ROUTES.unauthorized]);
					return;
				}

				this._router.navigate([APP_ROUTES.login]);
				return;
			}

			if(errorResponse.status == '0'){
				this._router.navigate([APP_ROUTES.connectionFailed]);
				return;
			}

			// TODO: better job of transforming error for user consumption
			//this.log(`${operation} failed: ${error.message}`);

			// Let the app keep running by returning an empty result.
			if (result == undefined) {
				return of(errorResponse.error as T);
			}

			return of(result as T);
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/services/log.service.ts